import { useUserStore } from '@st/user/stores/useUserStore'
import { useTelegram } from '@st/telegram/composables/useTelegram'
import { providePaymentsDeps } from '@st/payments/useDeps'
import DepositBonusBanner from '@st/bonuses/components/DepositBonusBanner/DepositBonusBanner.vue'

export default defineNuxtPlugin({
  name: 'paymentsDeps',
  dependsOn: ['i18n:plugin', 'i18n-base-init'],
  setup: () => {
    const { isTelegramMiniApp } = useTelegram()

    const userStore = useUserStore()
    const { userSettings, isAuthenticated, isJustRegisteredUser, user } =
      storeToRefs(userStore)
    const { updateUserSettings } = userStore

    const { hasTelegramProvider, hasWalletConnectProvider } =
      useUserAuthProviders()

    providePaymentsDeps({
      // Технически это циклическая зависимость, но фактически не совсем
      DepositBonusBanner,
      isTelegramMiniApp,
      isAuthenticated,
      isJustRegisteredUser,
      hasTelegramAuthProvider: hasTelegramProvider,
      hasWalletConnectAuthProvider: hasWalletConnectProvider,
      userEmail: computed(() => user.value?.email ?? ''),
      preferredAccountType: computed(
        () => userSettings.value?.preferredAccountType ?? 'real',
      ),
      preferredCurrencyCode: computed(
        () => userSettings.value?.preferredCurrencyCode ?? 'USDT',
      ),
      preferredCurrencyCodeForCurrencyExchange: computed(
        () =>
          userSettings.value?.preferredCurrencyCodeForCurrencyExchange ?? 'USD',
      ),
      showZeroAccounts: computed(
        () => userSettings.value?.showZeroAccounts ?? true,
      ),
      //@ts-expect-error incompatible types
      updateUserSettings,
      isUserSettingsSet: computed(() => !!userSettings.value),
      updateUserPreferredCurrencyCode: (currencyCode) =>
        updateUserSettings([
          {
            name: 'preferredCurrencyCode',
            value: currencyCode,
          },
        ]),
    })
  },
})
